export interface PriorityRulesState {
  priorityRules: PriorityRuleItem[],
  priorityRuleItem?: PriorityRuleItem
}

export interface PriorityRuleFilter {
  originator?: string,
  partner?: string,
  template?: string,
  priority?: number
}

export interface PriorityRuleItem {
  id?: number
  originator?: string,
  originator_id?: number|null,
  partner?: string,
  partner_id?: number|null,
  template?: string,
  template_id?: number|null,
  priority: number
}

export class PriorityRuleItemImpl implements PriorityRuleItem {
  priority: number;
  originator_id?: number|null;
  partner_id?: undefined;
  template_id?: number|null;

  constructor() {
    this.priority=4;
  }
}